/**
 * Capabilities Tab Prompt Builder
 *
 * Generates a UML class diagram prompt from EA application and organization data.
 * Groups capabilities by domain, showing classes with attributes and operations.
 */

import type { BulkEAImport } from '../../canister-client';
import type { ChatMessage } from '../../canister-client';
import { baseSvgRules, summarizeEntities } from './base-svg-prompt';

export function buildCapabilitiesPrompt(data: BulkEAImport): ChatMessage[] {
    const apps = summarizeEntities(data.applications, [
        'name', 'domain', 'app_type', 'description', 'criticality',
    ]);
    const techSvcs = summarizeEntities(data.technical_services, [
        'name', 'service_type', 'api_interface', 'application',
    ]);

    return [
        {
            role: 'user',
            content: `${baseSvgRules()}

DIAGRAM TYPE: UML Business Capability Model (class diagram style)

DATA - Applications:
${apps}

DATA - Technical Services:
${techSvcs}

INSTRUCTIONS:
- Group capabilities by their "domain" field into labeled sections.
- Each capability is shown as a UML class box with:
  - Class name (bold, top section)
  - Attributes section (application names and types)
  - Operations section (service endpoints derived from technical services)
- Use blue accent headers for each domain section.
- Arrange domains in a grid layout (2-3 columns) to fill the viewport.
- Draw dependency arrows between capabilities that share integrations.
- Add a title "Business Capability Model" at the top.`,
        },
    ];
}
